import React, {Component} from 'react';
import request from '../request';
import DelayedJobWatcher from '../delayed_job_watcher';

import GroupsContainer from './groups_container';
import Loading from './loading';
import {TrialHeader, TrialBottomNav} from './trial_partials';
import ReactJson from 'react-json-view'

export default class TrialGroupsImporterMl extends Component{
  constructor(props) {
    super(props);
    let {cycles_length} = props;
    this.state = {cycles_length};
    this.onChangeGroups = this.onChangeGroups.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.fetchGroups();
  }

  fetchGroups() {
    let {trial} = this.props;
    let url = `/admin/trials/${trial.id}/groups/infer`;
    this.setState({loading: true});
    request('GET', url).then(response => {
      if (response.delayed_job_id) {
        DelayedJobWatcher(response.delayed_job_id)
          .then(() => this.fetchGroups())
          .catch(error => this.setState({error}));
        return;
      }

      let {groups, inferred_data} = response;
      this.setState({groups, inferred_data, loading: false});
    });
  }

  regenerateGroupInformation() {
    let {trial} = this.props;
    let url = `/admin/trials/${trial.id}/groups/regenerate_group_information`;
    request('POST', url).then(response => {
      this.setState({loading: true});
      DelayedJobWatcher(response.delayed_job_id)
        .then(() => this.fetchGroups())
        .catch(error => this.setState({error}));
    });
  }

  submit() {
    let confirmation = 'You will delete any existing groups and replace with these new groups. Are you sure?';
    if (!confirm(confirmation)) return;

    let {trial} = this.props;
    let {groups, cycles_length} = this.state;

    let url = `/admin/trials/${trial.id}/groups`;
    request('PUT', url, {groups_data: {groups, cycles_length}}).then(r => {
      let back_path = `/admin/trials/${trial.id}/edit`
      window.location = back_path;
    });
  }

  onChangeGroups(groups, callback) {
    this.setState({groups}, callback);
  }

  onChange(e) {
    let {name, value} = e.target;
    this.setState({[name]: value});
  }

  unknownItemsPresent() {
    let {groups} = this.state;
    for (let group of groups) {
      if (group.unknown_items && group.unknown_items.length > 0) {
        return true;
      }
    }
    return false;
  }

  renderDate() {
    let {inferred_data} = this.state;
    if (!inferred_data || !inferred_data.created_at) return null;
    let date = moment(inferred_data.created_at).format('LLL');
    return <p><i>From data generated at {date}</i></p>
  }

  renderWarnings() {
    let {inferred_data} = this.state;
    if (!inferred_data || !inferred_data.warnings || inferred_data.warnings.length === 0) return null;

    return (
      <div className="alert alert-warning" role="alert">
        <h1>Warnings</h1>
        {inferred_data.warnings.map((warning, index) => {
          return (
            <div key={index}>
              <h3>{warning.group_label}</h3>
              <p>{warning.message}</p>
            </div>
          )
        })}
      </div>
    )
  }


  renderLoading() {
    return (
      <div>
        <h1>Getting group information</h1>
        <h2>Please wait..</h2>
        <Loading />
      </div>
    )
  }

  render() {
    let {loading, groups, cycles_length, inferred_data} = this.state;
    if (loading || !groups) return this.renderLoading();
    let {trial, trial_data, current_admin} = this.props;
    let submit_disabled = this.unknownItemsPresent();
    let return_path = `/admin/trials/${trial.id}/edit`;
    let ct_link = trial.study_url + '#armgroup';

    return (
      <div>
        <TrialHeader trial={trial} />
        <div className="pull-right">
          <a href={ct_link} target="_blank" className="btn btn-primary">Open on CT.gov</a>
          <button className="btn btn-default" onClick={e => this.regenerateGroupInformation()}>Regenerate Group Information</button>
          <a href={return_path} className='btn btn-default'>Return to Trial</a>
        </div>

        <h1>Review Imported Groups</h1>
        {this.renderDate()}
        <div className="row">
          <div className="col-md-6">
            <GroupsContainer trial={trial} groups={groups} onChange={this.onChangeGroups} closeable={true} currentAdmin={current_admin} createLinks changelog reviewItems={true} />

            <div className="form-group">
              <label>Cycle Length (In Weeks)</label>
              <input type="number" className="form-control" name="cycles_length" value={cycles_length || ''} onChange={this.onChange} />
            </div>

            <button className="btn btn-success" disabled={submit_disabled} onClick={e => this.submit()}>Save Groups</button>
            <a href={return_path} className="btn btn-default">Cancel and abandon changes</a>
          </div>

          <div className="col-md-6">
            {this.renderWarnings()}
            <TrialInformation trial_data={trial_data} />
            <ReactJson src={inferred_data} name="openai_data" sortKeys={true} displayDataTypes={false} displayObjectSize={false} />
          </div>
        </div>
        <TrialBottomNav trial={trial} action="group_importer" return_path={return_path}/>
      </div>
    )
  }
}

class TrialInformation extends Component {

  renderInterventions() {
    let {trial_data} = this.props;
    if (!trial_data.interventions || trial_data.interventions.length === 0) return null;

    return (
      <div>
        <h3>Interventions</h3>
        {trial_data.interventions.map((intervention, index) => {
          return (
            <div className="intervention group_panel_list" key={index}>
              <label>Type:</label> {intervention.type}<br/>
              <label>Name:</label> {intervention.name}<br/>
              <label>Description:</label> {intervention.description}<br/>
              <label>Label:</label> {intervention.armGroupLabels}<br/>
              <label>Other Name:</label>{intervention.other_name}<br/>
            </div>
          )
        })}
      </div>
    )
  }

  renderArmGroups() {
    let {trial_data} = this.props;
    if (!trial_data.arm_groups || trial_data.arm_groups.length === 0) return null;
    return (
      <div>
        <h3>ARM Groups</h3>
        {trial_data.arm_groups.map((arm_group, index) => {
          return (
            <div className="group_panel_list" key={index}>
              <label>Label:</label> {arm_group.label}<br/>
              <label>Type:</label> {arm_group.type}<br/>
              <label>Description:</label> {arm_group.description}<br/>
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.renderArmGroups()}
        {this.renderInterventions()}
      </div>
    )
  }
}
